<template>
  <div class="news">
    <p class="newTitle">案例展示</p>
    <div class="newsType">
      <div class="lTitle">
        <span>CASE</span>
      </div>
      <div class="rType hidden-xs-only">
        <ul>
          <li
            @click="getStyle(index,item)"
            v-for="(item,index) in types"
            :class="[activeIndex == index?'active':'']"
          >
            {{item.name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <!-- <span
            v-if="index+1 != types.length">/</span>-->
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </li>
        </ul>
      </div>
      <div class="newsContent">
        <ul>
          <li
            v-for="(item,index) in caseList.slice(0,showL)"
            @click="$router.push({path:'/caseDetail',query:{id:item.id,name:name}})"
          >
            <div class="pic">
              <img :src="settings.apiBaseImg +item.image" alt />
            </div>
            <div class="caseTitle">{{item.name}}</div>
            <div class="caseIntro hidden-xs-only">{{item.describe}}</div>
            <div class="content hidden-xs-only">
              <p class="contentT">{{item.name}}</p>
              <p class="contentN">{{item.describe}}</p>
            </div>
          </li>
        </ul>
        <div class="more">
          <button @click="$router.push({path:'/case'})">更多</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../assets/js/request.js";
import qs from "qs";
export default {
  data() {
    return {
      types: [],
      activeIndex: 0,
      caseList: [],
      id: "",
      name: "",
      showL: 3,
    };
  },
  created() {
    //分类
    this.getType();
    //数据
    this.getData(this.id);
    var sUserAgent = navigator.userAgent;
    if (
      sUserAgent.indexOf("Android") > -1 ||
      sUserAgent.indexOf("iPhone") > -1 ||
      sUserAgent.indexOf("iPad") > -1 ||
      sUserAgent.indexOf("iPod") > -1 ||
      sUserAgent.indexOf("Symbian") > -1
    ) {
      this.showL = 4;
    }
  },
  methods: {
    getStyle(index, item) {
      this.activeIndex = index;
      this.name = item.name;
      this.getData(item.id);
    },
    getType() {
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/case_type",
          qs.stringify({}),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.types = res.data;
            this.name = res.data[0].name;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getData(id) {
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/case_list",
          qs.stringify({
            case_type_id: id,
          }),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.caseList = res.data.rows;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
  },
};
</script>

<style scoped="scoped">
.news {
  width: 100%;
  height: 900px;
  background: #ffffff;
  padding: 70px 220px;
}

.news .newTitle {
  height: 30px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 18px;
  cursor: pointer;
}

.newsType .lTitle {
  width: 10%;
  height: 40px;
  display: inline-block;
  line-height: 40px;
  cursor: pointer;
}

.lTitle span {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 18px;
  opacity: 0.5;
}

.newsType {
  margin-top: 20px;
}

.newsType .rType {
  display: inline-block;
  width: 89%;
  height: 40px;
  text-align: right;
  box-sizing: border-box;
}

.rType ul li {
  display: inline-block;
  line-height: 40px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #676767;
  cursor: pointer;
}

.active {
  color: #216bd1 !important;
}

.newsContent {
  width: 100%;
  height: auto;
  margin-top: 80px;
}

.newsContent ul li {
  width: 32%;
  height: 450px;
  box-sizing: border-box;
  display: inline-block;
  margin-right: 1%;
  cursor: pointer;
  position: relative;
  transition: all 0.5s ease;
}

.newsContent ul li:hover .content {
  transition: all 0.5s ease;
  display: block;
}

.newsContent ul li .pic {
  width: 100%;
  height: 70%;
  position: relative;
  margin: auto;
  overflow: hidden;
}

.pic img {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin-bottom: 20px;
  max-width: 100%;
  margin: auto;
  height: 100%;
}

.caseTitle {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 25px;
  text-align: center;
  margin-top: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.caseIntro {
  margin-top: 30px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  line-height: 21px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.content {
  display: none;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50%;
  background-color: #216bd1;
  padding: 40px 40px;
  transition: all 0.8s ease;
}

.content .contentT {
  text-align: center;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
}

.content .contentN {
  margin-top: 30px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.more {
  width: 100%;
  height: auto;
  text-align: center;
  margin-top: 80px;
}

.more button {
  width: 205px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #216bd1;
  border-radius: 5px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #216bd1;
  line-height: 19px;
}

@media screen and (max-width: 750px) {
  .news .newTitle {
    height: 30px;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    line-height: 0.1rem;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    color: #216bd1;
  }

  .newsType .lTitle {
    width: 100%;
    height: 40px;
    display: inline-block;
    line-height: 40px;
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
  }

  .lTitle span {
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    line-height: 18px;
    opacity: 0.5;
  }

  .news {
    width: 100%;
    height: auto;
    background: #ffffff;
    padding: 70px 20px;
  }

  .newsContent ul li {
    width: 45%;
    height: 600px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 1%;
    cursor: pointer;
    position: relative;
    transition: all 0.5s ease;
  }

  .newsContent ul li .pic {
    width: 100%;
    height: 80%;
  }

  .pic img {
    width: 100%;
    height: 100%;
  }

  .newsContent ul li:hover .caseTitle {
    background-color: #216bd1;
  }

  .newsContent ul li:hover .caseTitle {
    color: #ffffff;
  }

  .caseTitle {
    width: 100%;
    height: 20%;
    background: #f5f5f5;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 0.6rem;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 20px;
    margin-top: 0;
  }

  .more {
    width: 100%;
    height: auto;
    text-align: center;
    margin-top: 40px;
  }

  .more button {
    width: 2rem;
    height: 0.45rem;
    background: #ffffff;
    border: 1px solid #216bd1;
    border-radius: 5px;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #216bd1;
    line-height: 19px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/case.vue